import { cn } from '@/helpers/utils/functionality-utils';
import React from 'react';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

export interface LabelWrapInterface {
  label: string | React.ReactNode;
  labelElement?: React.ReactNode;
  id?: string;
  error?: unknown;
  containerClassName?: string;
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
  containerStyles?: React.CSSProperties;
  iconFieldClassname?: string;
  labelClassname?: string;
  children: React.ReactNode;
  icon?: string | React.ReactNode;
  iconPos?: 'left' | 'right';
  imp?: boolean;
  matchTitleOfInfoText?: boolean;
}

export const LabelWrapper = ({
  label,
  id,
  error,
  containerClassName,
  containerProps,
  containerStyles,
  iconFieldClassname,
  labelClassname,
  children,
  icon,
  iconPos = 'left',
  imp,
  matchTitleOfInfoText,
  labelElement,
}: LabelWrapInterface) => {
  const _icon =
    typeof icon === 'string' ? (
      <IconField
        className={cn('w-full', iconFieldClassname)}
        iconPosition={iconPos}
      >
        {children}
        <InputIcon className={icon}> </InputIcon>
      </IconField>
    ) : (
      <IconField
        className={cn('w-full', iconFieldClassname)}
        iconPosition={iconPos}
      >
        {children}
        <InputIcon>{icon} </InputIcon>
      </IconField>
    );
  return (
    <div
      style={containerStyles}
      className={cn('flex flex-col', containerClassName, label && 'gap-2')}
      {...containerProps}
    >
      {labelElement || (
        <label
          htmlFor={id}
          className={cn(
            'flex shrink-0 overflow-hidden text-ellipsis whitespace-nowrap text-base font-semibold',
            labelClassname,
            matchTitleOfInfoText && 'text-lg font-bold text-surface-900',
          )}
        >
          {label}
          {imp && <span className="ml-1 text-red-500"> *</span>}
        </label>
      )}
      {icon ? _icon : children}
      {typeof error === 'string' && (
        <small className="p-error text-xs">{error}</small>
      )}
    </div>
  );
};
